<template>
	<div>
		<div class="input__wrapper" v-if="!data.onlyInputs">
			<label :class="data.labelClass">
				<span class="input-label" :id="data.labelId">{{ data.label }}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>

				<input
					type="text"
					v-model="displayValue"
					@blur="isInputActive = false"
					@focus="isInputActive = true"
					:id="data.inputId"
					:name="data.name"
					:placeholder="data.placeholder"
					:class="data.classinput"
					:disabled="isDisabled"
				/>
			</label>
		</div>
		<input
			v-else
			type="text"
			v-model="displayValue"
			@blur="isInputActive = false"
			@focus="isInputActive = true"
			:id="data.inputId"
			:name="data.name"
			:placeholder="data.placeholder"
			:class="data.classinput"
			:disabled="isDisabled"
		/>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		value: {
			type: [String, Number],
			require: false
		},
		currency: {
			type: Boolean,
			require: false
		},
		isDisabled: {
			type: Boolean,
			require: false
		}
	},
	// ['data', 'value', 'currency', 'isDisabled'],
	data () {
		return {
			isInputActive: false
		};
	},
	computed: {
		displayValue: {
			get: function() {
				if (this.isInputActive) {
					if (!this.value && this.value !== 0) {
						return '';
					} else {
						return this.value.toString();
					}
				} else {
					if (!this.value && this.value !== 0) {
						return '';
					} else {
						if (this.currency || this.data.currency) {
							return '$' + this.value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
						} else {
							return this.value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
						}
					}
				}
			},
			set: function(modifiedValue) {
				let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''));
				if (isNaN(newValue)) {
					newValue = '';
				}
				this.$emit('input', newValue);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.input__wrapper {
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $white-lilac;
		border-radius: 14px;
		padding: 14px 16px;
		max-width: 100%;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		background-color: $white-lilac;

		@include mq($sm) {
			font-size: 16px;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}
</style>
